import React, { useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { DownloadIcon, MenuIcon, XIcon } from 'lucide-react';
import { navLinks, profile } from '../data/profile';
import { downloadResume } from '../utils/resumePdf';
export function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);
  const linkClasses = (isActive: boolean) => `relative block whitespace-nowrap rounded px-2.5 py-2 text-[13px] font-medium transition-colors duration-150 ease-premium focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-navy focus-visible:ring-offset-2 ${isActive ? 'text-navy' : 'text-charcoal-muted hover:text-navy'}`;
  return <header className={`sticky top-0 z-50 w-full border-b bg-white/95 backdrop-blur transition-[border-color,box-shadow] duration-200 ease-premium ${scrolled || menuOpen ? 'border-line shadow-[0_1px_20px_rgba(15,23,42,0.06)]' : 'border-transparent'}`} data-id="element-335" data-mp="2rm1a34vdry7p">
      <div className="mx-auto flex h-20 max-w-shell items-center justify-between gap-6 px-6 sm:px-8" data-id="element-336" data-mp="3fb2l8zvllngo">
        <Link to="/" className="flex items-center gap-3" data-id="element-337" data-mp="3aciw6qlpjvk3">
          <span className="flex h-9 w-9 shrink-0 items-center justify-center border border-metal font-serif text-[13px] font-semibold text-navy" aria-hidden="true" data-id="element-338" data-mp="3ad11ecqclk45">
            KB
          </span>
          <span className="font-serif text-base font-semibold tracking-tight text-navy sm:text-lg" data-id="element-339" data-mp="1w5zp0lae5rn">
            {profile.shortName}
          </span>
        </Link>

        <div className="hidden items-center gap-4 xl:flex" data-id="element-340" data-mp="3t9skom5w3z87">
          <nav aria-label="Primary" data-id="element-341" data-mp="1rdbdqti0xatt">
            <ul className="flex items-center gap-0.5" data-id="element-342" data-mp="1recw7j1dczlk">
              {navLinks.map(link => <li key={link.to} data-id="element-343" data-mp="1wbuvsithy2gw">
                  <NavLink to={link.to} end className={({
                isActive
              }) => linkClasses(isActive)} data-id="element-344" data-mp="1ho1hd1g5d5zw">
                    {({
                  isActive
                }) => <>
                        {link.label}
                        <span aria-hidden="true" className={`absolute inset-x-2.5 -bottom-px h-0.5 bg-metal transition-opacity duration-150 ease-premium ${isActive ? 'opacity-100' : 'opacity-0'}`} data-id="element-345" data-mp="18nbskhpb0fvo" />
                      </>}
                  </NavLink>
                </li>)}
            </ul>
          </nav>

          <button type="button" onClick={downloadResume} className="inline-flex shrink-0 items-center gap-2 bg-navy px-4 py-2.5 text-[12px] font-semibold uppercase tracking-[0.08em] text-white transition-colors duration-150 ease-premium hover:bg-navy-deep focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-navy focus-visible:ring-offset-2" data-id="element-346" data-mp="2t13ypyq2lzl4">
            <DownloadIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-347" data-mp="w6am7g1aq4vk" />
            CV
          </button>
        </div>

        <button type="button" onClick={() => setMenuOpen(open => !open)} aria-expanded={menuOpen} aria-controls="mobile-nav" aria-label={menuOpen ? 'Close menu' : 'Open menu'} className="flex h-10 w-10 items-center justify-center border border-line text-navy transition-colors duration-150 ease-premium hover:border-navy/40 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-navy xl:hidden" data-id="element-348" data-mp="154w55caojlwv">
          {menuOpen ? <XIcon className="h-5 w-5" data-id="element-349" data-mp="3bvvkk313cvy1" /> : <MenuIcon className="h-5 w-5" data-id="element-350" data-mp="3bwni3je913qy" />}
        </button>
      </div>

      {menuOpen && <nav id="mobile-nav" aria-label="Mobile" className="border-t border-line bg-white xl:hidden" data-id="element-351" data-mp="22zgkq1y88ime">
          <ul className="mx-auto max-w-shell px-6 py-2 sm:px-8" data-id="element-352" data-mp="27wp5maarf0rc">
            {navLinks.map(link => <li key={link.to} data-id="element-353" data-mp="2cxwb22pfjnuu">
                <NavLink to={link.to} end className={({
            isActive
          }) => `block border-b border-line py-4 text-[15px] font-medium transition-colors duration-150 ease-premium ${isActive ? 'text-navy' : 'text-charcoal-muted'}`} data-id="element-354" data-mp="2cuqnwt0d2w1r">
                  {link.label}
                </NavLink>
              </li>)}
            <li className="py-5" data-id="element-355" data-mp="1y0dsji3ci6vu">
              <button type="button" onClick={downloadResume} className="inline-flex items-center gap-2 bg-navy px-5 py-3 text-[13px] font-semibold uppercase tracking-[0.08em] text-white transition-colors duration-150 ease-premium hover:bg-navy-deep focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-navy focus-visible:ring-offset-2" data-id="element-356" data-mp="1y1os15prcsh5">
                <DownloadIcon className="h-4 w-4" aria-hidden="true" data-id="element-357" data-mp="oz2apiuz2ypf" />
                Download CV
              </button>
            </li>
          </ul>
        </nav>}
    </header>;
}